import { Guides } from '@insta-club/models';
import CloseBtn from '../button/close-btn';
import Dialog from '../dialog';
import GuideVideo from '../media/guide-video';

interface Props {
    guide?: Guides;
    open: boolean;
    openKey?: string;
    onClose: () => void;
    className?: string;
}

const GuideDialog: React.FC<Props> = ({ guide, open, openKey, className, onClose }) => {
    return (
        <Dialog open={open} openKey={openKey} onClose={onClose} className={className}>
            <div className='absolute top-4 left-4 z-50'>
                <CloseBtn onClick={onClose} />
            </div>
            {guide ? <GuideVideo guide={guide} /> : null}
        </Dialog>
    );
};

export default GuideDialog;

